// extracted by mini-css-extract-plugin
export default {"overlay":"ResponseLoader_overlay__ghmA-","overlayRoot":"ResponseLoader_overlayRoot__m+Tj1","overlayFull":"ResponseLoader_overlayFull__3TSXK","text":"ResponseLoader_text__rdZTE"};